<template>
  <q-dialog
    :value="open"
    position="right"
    transition-show="slide-left"
    transition-hide="slide-right"
    class="absolute"
    @hide="$emit('hide')"
  >
    <q-card class="preview-card-wrapper">
      <q-linear-progress :value="1" color="primary" />
      <q-card-section class="q-pa-none preview-header bg-primary text-white">
        <div class="row items-center">
          <span class="text-h5 q-px-md">
            {{ type === 'quote' ? 'Quote' : 'Order' }}
            ID: #{{ quoteIdValue }}
          </span>
        </div>
        <app-power-search-input />
        <span
          class="row items-center text-primary cursor-pointer"
          @click="handleNewWindow"
        >
          <q-icon style="font-size: 1.5rem" name="open_in_new"></q-icon>
          <strong class="text-h6 q-px-sm text-white">
            Open {{ type === 'quote' ? 'Quote' : 'Order' }} in a new window
          </strong>
        </span>
      </q-card-section>
      <q-card-section :flat="true" class="q-pt-md">
        <app-quote-detail
          ref="quoteDetailRef"
          :quoteId="data"
          :quoteType="type"
        >
          <template #afterTitle>
            <div class="quote-nav">
              <q-btn
                v-if="hasPreviousQuote && !savingAndPrev"
                @click="handleGoPrevious"
                padding="xs"
                color="primary"
                icon="navigate_before"
                outline
              >
                <q-tooltip>Save and Previous</q-tooltip>
              </q-btn>
              <q-spinner v-if="savingAndPrev" />

              <q-btn
                v-if="hasNextQuote && !savingAndNext"
                @click="handleGoNext"
                padding="xs"
                color="primary"
                icon="navigate_next"
                outline
              >
                <q-tooltip>Save and Next</q-tooltip>
              </q-btn>
              <q-spinner v-if="savingAndNext" />
            </div>
          </template>
        </app-quote-detail>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
<script>
import AppQuoteDetail from '@client/pages/quotes/detail';
import AppPowerSearchInput from '@client/components/filters/power-search';

export default {
  name: 'AppQuotePreviewDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: String,
    type: {
      type: String,
      default: 'quote'
    },
    quote: {
      type: Object,
      default: () => {}
    },
    hasNextQuote: Boolean,
    hasPreviousQuote: Boolean
  },
  components: {
    AppQuoteDetail,
    AppPowerSearchInput
  },
  data() {
    return {
      savingAndNext: false,
      savingAndPrev: false
    };
  },
  computed: {
    quoteIsFromProabd() {
      return this.quote && this.quote.isFromProabd;
    },
    quoteIdValue() {
      return this.quote?.isFromProabd ? `LD${this.quote?.proabdExternalId}` : this.data;
    }
  },
  methods: {
    async handleGoNext() {
      this.savingAndNext = true;
      try {
        await this.$refs.quoteDetailRef.handleUpdate();
        this.$emit('goNext');
      } catch (error) {
        console.log('cant go to next due to an error', error);
      }
      this.savingAndNext = false;
    },
    async handleGoPrevious() {
      this.savingAndPrev = true;
      try {
        await this.$refs.quoteDetailRef.handleUpdate();
        this.$emit('goPrevious');
      } catch (error) {
        console.log('cant go to previous due to an error', error);
      }
      this.savingAndPrev = false;
    },
    handleNewWindow() {
      const routeData = this.$router.resolve({
        name: this.type === 'quote' ? 'quote-detail' : 'order-detail',
        params: { id: this.data },
        query: { edit: true }
      });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-card-wrapper {
  min-width: calc(100vw - 230px);
  min-height: 100vh;
  top: -25px;

  .preview-header {
    height: 80px;
    width: 100% !important;
    box-shadow: 0px 0px 5px 0px #d6d6d6;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.quote-nav::v-deep .material-icons {
  font-weight: bold;
}
</style>
